import type { AuthenticationAction } from "domains/authentication/actionTypes";
import { AuthenticationType } from "domains/authentication/actionTypes";
import type { AuthenticationState } from "domains/authentication/types";
import { addUnauthenticatedReset } from "domains/authentication/utils";

export const initialState: AuthenticationState = { idToken: undefined };

const authentication = (state = initialState, action: AuthenticationAction): AuthenticationState => {
  switch (action.type) {
    case AuthenticationType.LOGIN_FULFILLED:
      return { idToken: action.payload.idToken };
    default:
      return state;
  }
};

export const authenticationReducer = addUnauthenticatedReset(authentication, initialState);
